import type {AgentMetadata} from '../../types/chatTypes';
import {Box} from '@mui/material';

const LOGO_BY_APP_NAME = {
    atlas: "/assets/agentsLogo/Atlas.svg",
    maverick_spend_agent: "/assets/agentsLogo/MaverickSpendAgent.svg",
    ppv_agent: "/assets/agentsLogo/PPVAgent.svg",
    price_leakage_agent: "/assets/agentsLogo/PriceLeakageAgent.svg",
    external_benchmark_agent: "/assets/agentsLogo/ExternalBenchmarkAgent.svg",
    tail_spend_agent: "/assets/agentsLogo/TailSpendAgent.svg",
    rebate_capture_agent: "/assets/agentsLogo/RebateCaptureAgent.svg",
};

function resolveSvg(appName: string) {
    const src = LOGO_BY_APP_NAME[appName];
    return src ? <img src={src} alt={appName}/> : undefined;
}

/** Bot avatar / typing indicator: same assets as the agent picker, keyed by `app_name` from the session. */
export function SessionAgentLogoIcon({
                                         appName,
                                     }: {appName: string}) {
    const src = LOGO_BY_APP_NAME[appName] || '/assets/agentsLogo/Atlas.svg';
    return <img src={src} alt={appName || 'atlas'} width={36} height={36}/>;
}


/** Logo for the agent row (metadata from agents-metadata API). */
export function AgentLogoIcon({agent}: {agent: AgentMetadata}) {
    return resolveSvg(agent.app_name) ||
        <Box sx={{width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#000'}}></Box>;
}
